export default "__VITE_ASSET__CdMSFwIA__"